<fa-icon [icon]="[utilisateur.actif ? 'fas': 'far', 'check-circle']" (click)="updateStatut()" *hasRole="'INTERVENANT_UTILISATEUR_DESACTIVATION'; elseDisable"
  [ngClass]="{'actif': utilisateur.actif}"></fa-icon>